// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b44de9c3","128":"d5bb0c77","584":"1a36545a","667":"49ef5649","918":"dc78e0f3","974":"2521a5da"}[chunkId] + ".chunk.js";
};